export default __webpack_public_path__ + "static/media/incoming_chat.88f3465b.mp3";